import { render } from "./ApplyImplantHospital.vue?vue&type=template&id=95281436&scoped=true"
import script from "./ApplyImplantHospital.vue?vue&type=script&lang=js"
export * from "./ApplyImplantHospital.vue?vue&type=script&lang=js"

import "./ApplyImplantHospital.vue?vue&type=style&index=0&id=95281436&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-95281436"]])

export default __exports__